import React from 'react';
import styled from 'styled-components';
import { SidebarButton, SidebarOuterButton } from '@ui/molecules';
import { Divider } from '@ui/atoms';
import { WorkMode } from './';
import profileSvg from '@images/svg/profile.svg';
import enterSvg from '@images/svg/enter.svg';
import projectsSvg from '@images/svg/projects.svg';
import subscribeSvg from '@images/svg/subscribe.svg';
import balanceSvg from '@images/svg/dashboard-copy.svg';
import dateSvg from '@images/svg/date.svg';
import teamSvg from '@images/svg/team.svg';
import renderSvg from '@images/svg/ic_render.svg';
// import { ToggleSidebar } from '../atoms';
import { TariffButton } from './tariff-button';
import { withToggle, withStickyPosition } from '../../../hoc';
import { compose } from 'recompose';
import i18next from 'i18next';
import { connect } from 'react-redux';
import { selectUserData } from '../selectors';
import { RenderIfConnected } from './render-if';
import { IPaymentOptions } from 'planoplan-ui-kit/core/icons/i-payment-options';
import { Colors } from 'planoplan-ui-kit/core/colors';

const mapStateToProps = (state) => ({
  showRenderListButton: selectUserData(state).options.renderList,
  isStandalone: state.root.isStandalone,
});

const enchance = compose(connect(mapStateToProps), withToggle(true), withStickyPosition(80));

export const SidebarView = ({ toggle, toggled, isStuck, showRenderListButton, isStandalone }) => (
  <React.Fragment>
    <Spacer open={toggled} />
    <Container open={toggled} isStuck={isStuck}>
      <InnerSidebar>
        <ToggleSibebarContainer isStuck={isStuck}>
          {/*<ToggleSidebar open={toggled} onClick={toggle} />*/}
        </ToggleSibebarContainer>
        <WorkMode match="SOLO">
          {(mode) => (
            <SoloMenu
              open={toggled}
              showRenderListButton={showRenderListButton}
              isStandalone={isStandalone}
              mode={mode}
            />
          )}
        </WorkMode>
        <WorkMode match="TEAM_FOUNDER">
          {(mode) => <TeamFounderMenu open={toggled} showRenderListButton={showRenderListButton} mode={mode} />}
        </WorkMode>
        <WorkMode match="TEAM_MEMBER">
          {(mode) => <TeamMemberMenu open={toggled} showRenderListButton={showRenderListButton} mode={mode} />}
        </WorkMode>
      </InnerSidebar>
    </Container>
  </React.Fragment>
);

export const Sidebar = enchance(SidebarView);

const SoloMenu = ({ open, showRenderListButton, isStandalone }) => (
  <React.Fragment>
    {!isStandalone && (
      <SidebarButton icon={projectsSvg} to="/" open={open} text={i18next.t('Проекты')} activeOnlyWhenExact={true} />
    )}
    <Divider />
    <SidebarButton icon={balanceSvg} open={open} text={i18next.t('cabinet.balance.title')} to="/balance" />
    <Divider />
    <RenderIfConnected cond={showRenderListButton} noText>
      <SidebarOuterButton icon={renderSvg} open={open} text={i18next.t('renders.index.title')} href="/renders" />
      <Divider />
    </RenderIfConnected>
    <SidebarButton icon={profileSvg} open={open} text={i18next.t('cabinet.profile.title')} to="/profile" />
    <SidebarButton icon={enterSvg} open={open} text={i18next.t('cabinet.login_settings.title')} to="/login-options" />
    <SidebarButton
      icon={subscribeSvg}
      open={open}
      text={i18next.t('cabinet.subscriptions.title')}
      to="/subscriptions"
    />
    <Divider />
    <SidebarButton
      svg={<IPaymentOptions fill={Colors.coal} />}
      open={open}
      text={i18next.t('cabinet.payment.title')}
      to="/payment-options"
    />
    <SidebarButton icon={dateSvg} open={open} text={i18next.t('cabinet.history.title')} to="/history-payment" />
    <Divider />
    <TariffButton open={open} />
  </React.Fragment>
);

const TeamFounderMenu = ({ open, showRenderListButton }) => (
  <React.Fragment>
    <SidebarButton icon={projectsSvg} open={open} to="/" text={i18next.t('Проекты')} activeOnlyWhenExact={true} />
    <Divider />
    <SidebarButton icon={balanceSvg} open={open} text={i18next.t('cabinet.balance.title')} to="/balance" />
    <Divider />
    <RenderIfConnected cond={showRenderListButton} noText>
      <SidebarOuterButton icon={renderSvg} open={open} text={i18next.t('renders.index.title')} href="/renders" />
      <Divider />
    </RenderIfConnected>
    <SidebarButton icon={teamSvg} open={open} text={i18next.t('cabinet.members.title')} to="/members" />
    <SidebarButton icon={profileSvg} open={open} text={i18next.t('cabinet.team.profile.title')} to="/team-profile" />
    <Divider />
    <TariffButton open={open} />
  </React.Fragment>
);

const TeamMemberMenu = ({ open, showRenderListButton }) => (
  <React.Fragment>
    <SidebarButton icon={projectsSvg} open={open} to="/" text={i18next.t('Проекты')} activeOnlyWhenExact={true} />
    <Divider />
    <SidebarButton icon={balanceSvg} open={open} text={i18next.t('cabinet.balance.title')} to="/balance" />
    <Divider />
    <RenderIfConnected cond={showRenderListButton} noText>
      <SidebarOuterButton icon={renderSvg} open={open} text={i18next.t('renders.index.title')} href="/renders" />
      <Divider />
    </RenderIfConnected>
    <TariffButton open={open} />
  </React.Fragment>
);

const Container = styled.div`
  position: ${(p) => (p.isStuck ? 'fixed' : 'absolute')};
  top: 0;
  left: 0;
  bottom: 0;
  width: ${(p) => (p.open ? '228px' : '76px')};
  box-shadow: 0 0 34px 6px rgba(97, 108, 121, 0.13), -1px 1px 2px 0 rgba(97, 108, 121, 0.2);
  //border-right: 1px solid ${Colors.whisper};
  background-color: ${Colors.white};
  margin-right: 38px;
  font-size: 12px;
  transition: width 0.3s;
`;
const Spacer = styled.div`
  width: ${(p) => (p.open ? '228px' : '76px')};
  transition: width 0.3s;
`;

const ToggleSibebarContainer = styled.div`
  position: fixed;
  bottom: 23px;
  left: 26px;
`;
const InnerSidebar = styled.div`
  height: 100vh;
  position: relative;
`;
